export enum GeoTestAction {
  saveAsActive = 'save-as-active',
  updateTestActive = 'update-test-active',
  updateTestDraft = 'update-test-draft',
  saveAsDraft = 'save-as-draft',
  updateTest = 'update-test',
  saveAsInactive = 'save-as-inactive',
  downloadSummary = 'download-summary',
  cancel = 'cancel',
  exportData = 'export-data'
}

export enum ExportDataTrigger {
  testData = 'testData',
  historic = 'historic',
  calculations = 'calculations'
}

export enum ChartDurationType {
  HISTORIC = 'historic',
  TEST_DURATION = 'test-duration'
}

export interface ExportDataRequest {
  trigger: ExportDataTrigger;
  activeTabStudyId?: number;
  isBfsFlow?: boolean; // True for BFS flow (suppress toast), false/undefined for legacy flow (show toast)
}
